import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, Fade, IconButton, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const CopyValue = ({ sx = {}, value }) => {
    const [copied, setCopied] = useState(false);
    const { t } = useTranslation();

    const copyValueHandler = async () => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            toast.error(t("messages.copyMsgs.fail") || err.message);
        }
    };

    return (
        <Box
            sx={{
                alignItems: "center",
                borderRadius: "4px",
                display: "inline-flex",
                gap: 1,
                padding: "4px 8px",
                ...sx,
            }}
        >
            {/* Original value and copy icon */}
            <Fade in={!copied} timeout={200}>
                <Box
                    sx={{
                        alignItems: "center",
                        display: copied ? "none" : "flex",
                        gap: 1,
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#333",
                            fontFamily: "monospace",
                            fontSize: "14px",
                        }}
                    >
                        {value}
                    </Typography>
                    <IconButton
                        size="small"
                        sx={{
                            padding: "4px",
                        }}
                        onClick={copyValueHandler}
                    >
                        <ContentCopyIcon color="#666" fontSize="18px" />
                    </IconButton>
                </Box>
            </Fade>
            {/* Copied message */}
            <Fade in={copied} timeout={200}>
                <Box
                    sx={{
                        alignItems: "center",
                        display: copied ? "flex" : "none",
                        gap: 1,
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#4caf50",
                            fontSize: "14px",
                            fontWeight: 500,
                        }}
                    >
                        {t("labels.copied")}
                    </Typography>
                    <CheckIcon
                        sx={{
                            color: "#4caf50",
                            fontSize: "18px",
                        }}
                    />
                </Box>
            </Fade>
        </Box>
    );
};

CopyValue.propTypes = {
    sx: PropTypes.object,
    value: PropTypes.string.isRequired,
};

export default CopyValue;
